import React, { useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import { useForm } from "react-hook-form";
import Table from "react-bootstrap/Table";
import {
  base_url,
  LOAN_CURRENCY_TYPE_BHD,
  LOAN_CURRENCY_TYPE_USD,
  LOAN_REPAYMENT_BY_BUSINESS,
  STATUS_CLOSED,
} from "../utilities";
import {
  STATUS_NEW,
  STATUS_IN_PROGRESS,
  STATUS_APPROVED,
  STATUS_REJECTED,
  STATUS_PROCESSED,
  SERVICE_REQUEST_NEW_LOAN,
  SERVICE_REQUEST_EXTEND_TENURE,
  SERVICE_REQUEST_PRE_CLOSURE,
  SERVICE_REQUEST_PARTIAL_PRE_PAYMENT,
} from "../utilities";
import axios from ".././axios-interceptor";
import { toast } from "react-toastify";
import { Form } from "react-bootstrap";
import moment from "moment";
import Skeleton from "react-loading-skeleton";
import Cookies from 'js-cookie';

window.Buffer = window.Buffer || require("buffer").Buffer;
const AdminExtendTenureRequest = (props) => {
  const [returnPayments, setReturnPayements] = useState([]);
  const [returnPaymentsFilter, setReturnPayementsFilter] = useState([]);
  const [loading, setLoading] = useState(true);
  let returnPay = props.data.return_payments;
  useEffect(() => {
    if (props.data !== "" || props.data !== undefined) {
      setLoading(false);
    }
    if (returnPay !== undefined) {
      setReturnPayements(returnPay);
      setReturnPayementsFilter(returnPay);
    }
  }, [returnPay]);

  const [activeTab, setActiveTab] = useState("home-tab");
  const titles = [
    { title: "Investment Payment", field: "tenure_amount" },
    { title: "Tenure Date", field: "tenure_date" },
    { title: "Amount Repaid", field: "paid_amount" },
  ];
  const [sortOrder, setSortOrder] = useState({ column: null, direction: null });

  const handleSort = (column) => {
    let direction = "asc";
    if (sortOrder.column === column && sortOrder.direction === "asc") {
      direction = "desc";
    }
    setSortOrder({ column, direction });
    const sortedData = [...returnPayments].sort((a, b) => {
      const columnA = a[column];
      const columnB = b[column];
      if (typeof columnA === "string" && typeof columnB === "string") {
        return direction === "asc"
          ? columnA.localeCompare(columnB)
          : columnB.localeCompare(columnA);
      } else if (typeof columnA === "number" && typeof columnB === "number") {
        return direction === "asc" ? columnA - columnB : columnB - columnA;
      } else {
        return 0;
      }
    });
    setReturnPayementsFilter(sortedData);
  };

  const [assignee, setAssignee] = useState("");
  const [adminnotes, setAdminNotes] = useState("");
  const [show, setShow] = useState(false);
  const [extensionType, setExtensionType] = useState('');
  const [previewSchedule, setPreviewSchedule] = useState([]);
  const [previewLoading, setPreviewLoading] = useState(false);
  const [totalInterest, setTotalInterest] = useState(null);
  let loan_history_array = [];
  const handleShowReject = () => setShow(true);
  let download;
  if (props.data.documents == undefined) {
    download = [];
  } else {
    download = props.data.documents;
  }
  let user = Cookies.get("admin_user_name");
  if (props.data.loan_history != undefined) {
    props.data.loan_history.map((each_history_record) => {
      //NEW LOAN REQUEST LIST
      if (
        each_history_record.status == STATUS_NEW &&
        each_history_record.service_type_code == SERVICE_REQUEST_NEW_LOAN
      ) {
        let message = "Business requested loan";
        let created_date_time = each_history_record.created_date_time;
        let message_object = {
          message: message,
          created_date_time: created_date_time,
        };
        loan_history_array.push(message_object);
      }
      if (
        !each_history_record.is_investor_interested &&
        !each_history_record.is_admin_sent_terms_to_business
      ) {
        if (
          each_history_record.status == STATUS_IN_PROGRESS &&
          each_history_record.service_type_code == SERVICE_REQUEST_NEW_LOAN
        ) {
          let message =
            "Admin filled the profit percentage and sent to investors";
          let created_date_time = each_history_record.created_date_time;
          let message_object = {
            message: message,
            created_date_time: created_date_time,
          };
          loan_history_array.push(message_object);
        }
      }
      if (
        each_history_record.status == STATUS_REJECTED &&
        each_history_record.service_type_code == SERVICE_REQUEST_NEW_LOAN
      ) {
        let message = "Admin rejected the new loan request";
        let created_date_time = each_history_record.created_date_time;
        let message_object = {
          message: message,
          created_date_time: created_date_time,
        };
        loan_history_array.push(message_object);
      }
      if (
        each_history_record.status == STATUS_IN_PROGRESS &&
        each_history_record.is_investor_interested === 1 &&
        each_history_record.service_type_code == SERVICE_REQUEST_NEW_LOAN
      ) {
        let message = "Investor has shown interest on this loan";
        let created_date_time = each_history_record.created_date_time;
        let message_object = {
          message: message,
          created_date_time: created_date_time,
        };
        loan_history_array.push(message_object);
      }
      if (
        each_history_record.status == STATUS_IN_PROGRESS &&
        each_history_record.is_admin_sent_terms_to_business === 1 &&
        each_history_record.service_type_code == SERVICE_REQUEST_NEW_LOAN
      ) {
        let message =
          "Admin sent loan terms and awaiting for business response";
        let created_date_time = each_history_record.created_date_time;
        let message_object = {
          message: message,
          created_date_time: created_date_time,
        };
        loan_history_array.push(message_object);
      }

      if (
        each_history_record.status == STATUS_APPROVED &&
        each_history_record.service_type_code == SERVICE_REQUEST_NEW_LOAN
      ) {
        let message = "Business agreed the new loan request terms";
        let created_date_time = each_history_record.created_date_time;
        let message_object = {
          message: message,
          created_date_time: created_date_time,
        };
        loan_history_array.push(message_object);
      }

      if (
        each_history_record.status == STATUS_PROCESSED &&
        each_history_record.service_type_code == SERVICE_REQUEST_NEW_LOAN
      ) {
        let message = (
          <div className="style_loan_txt">
            Admin paid the requested loan amount{" "}
            <span
              style={{ color: "black", marginTop: "2px" }}
              className="ps-1 pe-1 fw-bold"
            >
              {each_history_record.paid_currency +
                " " +
                Number(each_history_record.paid_amount).toLocaleString()}
            </span>{" "}
            to business on{" "}
            <span
              style={{ color: "black", marginTop: "2px" }}
              className="ps-1 pe-1 fw-bold"
            >
              {moment(each_history_record.paid_date).format("DD MMM YYYY")}
            </span>
          </div>
        );
        let created_date_time = each_history_record.created_date_time;
        let message_object = {
          message: message,
          created_date_time: created_date_time,
        };
        loan_history_array.push(message_object);
      }
      if (
        each_history_record.status == LOAN_REPAYMENT_BY_BUSINESS &&
        each_history_record.service_type_code == SERVICE_REQUEST_NEW_LOAN
      ) {
        let message = (
          <div className="">
            Business repaid for the month of{" "}
            <span style={{ color: "black" }} className="fw-bold">
              {moment(each_history_record.tenure_date).format("MMMM")}
            </span>
            , loan tenure amount{" "}
            <span style={{ color: "black" }} className="fw-bold">
              {each_history_record.paid_currency +
                " " +
                Number(each_history_record.paid_amount).toLocaleString()}
            </span>{" "}
            to admin on{" "}
            <span style={{ color: "black" }} className=" fw-bold">
              {moment(each_history_record.paid_date).format("DD MMM YYYY")}
            </span>
          </div>
        );
        let created_date_time = each_history_record.created_date_time;
        let message_object = {
          message: message,
          created_date_time: created_date_time,
        };
        loan_history_array.push(message_object);
      }

      if (
        each_history_record.status == STATUS_NEW &&
        each_history_record.service_type_code == SERVICE_REQUEST_EXTEND_TENURE
      ) {
        let message = "Business requested to extend loan tenure";
        let created_date_time = each_history_record.created_date_time;
        let message_object = {
          message: message,
          created_date_time: created_date_time,
        };
        loan_history_array.push(message_object);
      }
      if (
        each_history_record.status == STATUS_APPROVED &&
        each_history_record.service_type_code == SERVICE_REQUEST_EXTEND_TENURE
      ) {
        let message = "Admin approved extend tenure request";
        let created_date_time = each_history_record.created_date_time;
        let message_object = {
          message: message,
          created_date_time: created_date_time,
        };
        loan_history_array.push(message_object);
      }

      if (
        each_history_record.status == STATUS_REJECTED &&
        each_history_record.service_type_code == SERVICE_REQUEST_EXTEND_TENURE
      ) {
        let message = "Admin rejected the extend tenure request";
        let created_date_time = each_history_record.created_date_time;
        let message_object = {
          message: message,
          created_date_time: created_date_time,
        };
        loan_history_array.push(message_object);
      }

      if (
        each_history_record.status == STATUS_NEW &&
        each_history_record.service_type_code == SERVICE_REQUEST_PRE_CLOSURE
      ) {
        let message = "Business requested for pre closure of a loan";
        let created_date_time = each_history_record.created_date_time;
        let message_object = {
          message: message,
          created_date_time: created_date_time,
        };
        loan_history_array.push(message_object);
      }
      if (
        each_history_record.status == STATUS_APPROVED &&
        each_history_record.service_type_code == SERVICE_REQUEST_PRE_CLOSURE
      ) {
        let message = "Admin approved pre closure request";
        let created_date_time = each_history_record.created_date_time;
        let message_object = {
          message: message,
          created_date_time: created_date_time,
        };
        loan_history_array.push(message_object);
      }
      if (
        each_history_record.status == STATUS_REJECTED &&
        each_history_record.service_type_code == SERVICE_REQUEST_PRE_CLOSURE
      ) {
        let message = "Admin rejected pre closure request";
        let created_date_time = each_history_record.created_date_time;
        let message_object = {
          message: message,
          created_date_time: created_date_time,
        };
        loan_history_array.push(message_object);
      }
      if (
        each_history_record.status == STATUS_NEW &&
        each_history_record.service_type_code == SERVICE_REQUEST_PARTIAL_PRE_PAYMENT
      ) {
        let message = "Business requested for partial pre-payment of a loan";
        let created_date_time = each_history_record.created_date_time;
        let message_object = {
          message: message,
          created_date_time: created_date_time,
        };
        loan_history_array.push(message_object);
      }
      if (
        each_history_record.status == STATUS_APPROVED &&
        each_history_record.service_type_code == SERVICE_REQUEST_PARTIAL_PRE_PAYMENT
      ) {
        let message = "Admin approved partial pre-payment request";
        let created_date_time = each_history_record.created_date_time;
        let message_object = {
          message: message,
          created_date_time: created_date_time,
        };
        loan_history_array.push(message_object);
      }
      if (
        each_history_record.status == STATUS_REJECTED &&
        each_history_record.service_type_code == SERVICE_REQUEST_PARTIAL_PRE_PAYMENT
      ) {
        let message = "Admin rejected partial pre-payment request";
        let created_date_time = each_history_record.created_date_time;
        let message_object = {
          message: message,
          created_date_time: created_date_time,
        };
        loan_history_array.push(message_object);
      }
      if (
        each_history_record.status == STATUS_CLOSED &&
        each_history_record.service_type_code == SERVICE_REQUEST_NEW_LOAN
      ) {
        let message = "Business repaid the loan successfully";
        let created_date_time = each_history_record.created_date_time;
        let message_object = {
          message: message,
          created_date_time: created_date_time,
        };
        loan_history_array.push(message_object);
      }
    });
  }

  let months = [];
  for (let i = 1; i <= 48; i++) {
    if (i % 1 === 0) {
      months.push(i);
    }
  }
  const handleClose = () => {
    props.onHide();
    setActiveTab("home-tab");
  };
  const closeButton = () => {
    props.onHide();
  };
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const handleCloseRejectClose = () => {
    setShow(false);
  };
  const handleCloseReject = () => {
    //hit the api from rejection api here
    let service_request_id = {
      service_request_id: props.data.service_request_id,
      admin_user_id: Cookies.get("admin_user_id"),
      assignee:
        assignee == "" ? Cookies.get("admin_user_name") : assignee,
      admin_notes: adminnotes,
    };
    axios
      .post(
        base_url + "service-request-trx/reject_tenure_extension",
        service_request_id
      )
      .then((res) => {
        if (res.data.status == 200) {
          setShow(false);

          toast.success("Rejected Successfully", {
            toastId: 4,
          });
          setTimeout(() => {
            window.location.reload();
          }, 800);
        }
      });
  };
  const [activeTabBool, setActiveTabBool] = useState(false);

  // const handleSavechanges = () => {
  //   setActiveTabBool(true);
  //   let service_request_id = {
  //     admin_user_id: Cookies.get("admin_user_id"),
  //     service_request_id: props.data.service_request_id,
  //     loan_id: props.data.loan_id,
  //     extend_tenure: props.data.extend_tenure,
  //     assignee:
  //       assignee == "" ? Cookies.get("admin_user_name") : assignee,
  //     admin_notes: adminnotes,
  //   };
  //   axios
  //     .post(
  //       base_url + "service-request-trx/approve_tenure_extension",
  //       service_request_id
  //     )
  //     .then((res) => {
  //       if (res.data.status == 200) {
  //         setShow(false);
  //         toast.success("Approved Successfully", {
  //           toastId: 4,
  //         });
  //         props.onHide();

  //         setTimeout(() => {
  //           window.location.reload();
  //         }, 800);
  //       }
  //     });
  // };

  const handleSavechanges = () => {
    if (!extensionType) {
      toast.error("Please select an extension type", { toastId: 10 });
      return;
    }
    setActiveTabBool(true);
    let service_request_id = {
      admin_user_id: Cookies.get("admin_user_id"),
      service_request_id: props.data.service_request_id,
      loan_id: props.data.loan_id,
      extend_tenure: props.data.extend_tenure,
      assignee:
        assignee == "" ? Cookies.get("admin_user_name") : assignee,
      admin_notes: adminnotes,
      extension_type: extensionType,   // NEW
    };
    axios
      .post(
        base_url + "service-request-trx/approve_tenure_extension",
        service_request_id
      )
      .then((res) => {
        if (res.data.status == 200) {
          setShow(false);
          toast.success("Approved Successfully", {
            toastId: 4,
          });
          props.onHide();

          setTimeout(() => {
            window.location.reload();
          }, 800);
        }
      });
  };
  const handleExtensionTypeChange = (e) => {
    const value = e.target.value;
    setExtensionType(value);
    setPreviewSchedule([]);
    setTotalInterest(null);

    if (!value) return;

    setPreviewLoading(true);
    axios
      .post(base_url + 'service-request-trx/extension/preview', {
        loan_id: props.data.loan_id,
        extension_type: value,
        extend_tenure: props.data.extend_tenure,
      })
      .then((res) => {
        if (res.data.status === 200) {
          setPreviewSchedule(res.data.data.schedule);
          setTotalInterest(res.data.data.total_interest);
        }
      })
      .catch((err) => {
        toast.error('Failed to load schedule preview', { toastId: 11 });
        console.log(err);
      })
      .finally(() => setPreviewLoading(false));
  };

  const handleChangeInput = (e) => {
    const target = e.target;
    const value = target.value;
    const name = target.name;
    if (name == "assignee") {
      setAssignee(value);
    }
    if (name === "admin_notes") {
      setAdminNotes(value);
    }
  };

  const handleDownload = async (url, document_type) => {
    try {
      const response = await fetch(url);
      const blob = await response.blob();
      const objectUrl = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = objectUrl;
      a.download = props.data.business_name + "_" + document_type; // file name
      a.click();
      URL.revokeObjectURL(objectUrl);
    } catch (err) {
      console.log(err);
    }
  };
  return (
    <>
      <Modal
        {...props}
        dialogClassName="modal-190w"
        aria-labelledby="example-custom-modal-styling-title"
        size="xl"
        backdrop="static"
        keyboard={false}
        centered
      >
        <Modal.Header onHide={handleClose} closeButton className="modal_title">
          <Modal.Title id="example-custom-modal-styling-title">
            <div className="heading_new_loan  ps-2">Extend Tenure Request</div>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="px-4 py-2 admin_all_preclosure_body" style={{ overflowY: 'auto', maxHeight: '70vh' }}>
          <div className="row ">
            <div className="col-lg-8">
              <div className="row mb-3">
                <div className="col-4">
                  <p className="text_st">Business Name</p>
                  <div className="text_bolder">
                    {" "}
                    {props.data.business_name === undefined ||
                    props.data.business_name === ""
                      ? "-"
                      : props.data.business_name}
                  </div>
                </div>
                <div className="col-4">
                  <p className="text_st">Loan Reference No.</p>
                  <div className="bolder_text">
                    {props.data.loan_reference_number === undefined ||
                    props.data.loan_reference_number === ""
                      ? "-"
                      : props.data.loan_reference_number}
                  </div>
                </div>
                <div className="col-4">
                  <p className="text_st">Loan Type</p>
                  <div className="bolder_text">
                    {props.data.loan_type_name === undefined ||
                    props.data.loan_type_name === ""
                      ? "-"
                      : props.data.loan_type_name}
                  </div>
                </div>
              </div>
              <div className="row mt-2 mb-3">
                <div className="col-4">
                  <p className="text_st">Requested Tenure </p>
                  <span className="bolder_text">
                    {props.data.loan_tenure === undefined ||
                    props.data.loan_tenure === ""
                      ? "-"
                      : props.data.loan_tenure +
                          " " +
                          props.data.loan_tenure ===
                        1
                      ? " Month"
                      : " Months"}
                  </span>
                </div>
                <div className="col-4">
                  <p className="text_st">Requested Loan Amount</p>
                  <span className="bolder_text">
                    {props.data.loan_currency == LOAN_CURRENCY_TYPE_USD
                      ? "$"
                      : LOAN_CURRENCY_TYPE_BHD}{" "}
                    {Number(props.data.loan_amount).toLocaleString()}
                  </span>
                </div>
                <div className="col-4">
                  <p className="text_st">Loan Purpose</p>
                  <span className="bolder_text">
                    {props.data.loan_purpose === undefined ||
                    props.data.loan_purpose === ""
                      ? "-"
                      : props.data.loan_purpose}{" "}
                  </span>
                </div>
              </div>
              <div className="row mb-1">
                <div className="col">
                  <p className="text_st"> Reason For Tenure Extension</p>
                  <div className="bolder_text ">
                    {" "}
                    {props.data.notes === undefined || props.data.notes === ""
                      ? "-"
                      : props.data.notes}
                  </div>
                </div>
              </div>
            </div>
            <div className="col">
              {download.map((item) => {
                return (
                  <div key={item.doc_type} className="row ">
                    <div className="col-lg-8 ps-2">
                      <article className="text_bolde_doc ">
                        {item.document_type}{" "}
                      </article>
                    </div>
                    <div className="col d-flex justify-content-center">
                      <span className="">
                        {" "}
                        <a
                          style={{ display: "table-cell" }}
                          href={item.document_url}
                          target="_blank"
                        >
                          <img src="./images/eye.svg" alt="" />
                        </a>
                      </span>
                      <span
                        className="Cpointer ps-3"
                        onClick={() =>
                          handleDownload(item.document_url, item.document_type)
                        }
                      >
                        <img src="./images/down.svg" alt="" />
                      </span>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
          <hr />
          <div className="row">
            <div className="col-6">
              {" "}
              <div className="row bg-white">
                <div className="col">
                  <ul
                    className="nav nav-tabs d-flex"
                    style={{ height: "50px" }}
                    id="myTab"
                    role="tablist"
                  >
                    <li className="nav-item" role="presentation">
                      <button
                        className="nav-link active ps-0"
                        id="home-tab"
                        data-bs-toggle="tab"
                        data-bs-target="#home-tab-pane"
                        type="button"
                        role="tab"
                        aria-controls="home-tab-pane"
                        aria-selected="true"
                        onClick={() => setActiveTab("home-tab")}
                      >
                        <h6 className="">Schedule Of Return Payments</h6>
                        {activeTab === "home-tab" && (
                          <img
                            style={{ marginTop: "-48px" }}
                            src="./images/polygondown.svg"
                            alt=""
                          />
                        )}
                      </button>
                    </li>
                    <li className="nav-item" role="presentation">
                      <button
                        className="nav-link "
                        id="profile-tab"
                        data-bs-toggle="tab"
                        data-bs-target="#profile-tab-pane"
                        type="button"
                        role="tab"
                        aria-controls="profile-tab-pane"
                        aria-selected="false"
                        onClick={() => setActiveTab("profile-tab")}
                      >
                        <h6>Loan History</h6>
                        {activeTab === "profile-tab" && (
                          <img
                            style={{ marginTop: "-48px" }}
                            src="./images/polygondown.svg"
                            alt=""
                          />
                        )}
                      </button>
                    </li>
                  </ul>
                </div>
                <div className="tab-content" id="myTabContent">
                  <div
                    className="tab-pane fade show active preclosure_Table_body"
                    id="home-tab-pane"
                    role="tabpanel"
                    aria-labelledby="home-tab"
                    tabIndex="0"
                  >
                    <div className="dsfasdfadsf">
                      <Table
                        striped
                        hover
                      >
                        <thead className="all_inv_table_head">
                          <tr>
                            {titles.map((column) => (
                              <th
                                key={column.field}
                                onClick={() => handleSort(column.field)}
                              >
                                {column.title}
                                &#9662;
                              </th>
                            ))}
                          </tr>
                        </thead>
                        <tbody>
                          {returnPaymentsFilter?.map((data, index) => {
                            return (
                              <tr key={index}>
                                <td>
                                  {loading ? (
                                    <Skeleton width={100} height={15} />
                                  ) : data.admin_request_loan_currency ===
                                    LOAN_CURRENCY_TYPE_BHD ? (
                                    "BHD " + data.tenure_amount
                                  ) : (
                                    "$ " + data.tenure_amount
                                  )}
                                </td>
                                <td>
                                  {loading ? (
                                    <Skeleton width={100} height={15} />
                                  ) : (
                                    moment(data.tenure_date).format("DD MMM YYYY")
                                  )}
                                </td>
                                <td>
                                  {loading ? (
                                    <Skeleton width={100} height={15} />
                                  ) : data.admin_request_loan_currency ===
                                    LOAN_CURRENCY_TYPE_BHD ? (
                                    "BHD " + data.paid_amount
                                  ) : (
                                    "$ " + data.paid_amount
                                  )}
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </Table>
                    </div>
                  </div>
                  <div
                    className="tab-pane fade loan_history_tab"
                    id="profile-tab-pane"
                    role="tabpanel"
                    aria-labelledby="profile-tab"
                    tabIndex="0"
                  >
                    <div className="row gap-3 ps-3 " style={{ height: "25vh" }}>
                      {loan_history_array.map((details) => {
                        return (
                          <div
                            key={details.message}
                            className="row pt-0 lh_custom_style"
                          >
                            <div className="style_loan">
                              <img
                                className="me-2"
                                src="./images/circle.svg"
                                alt=""
                                srcSet=""
                                height={16}
                                width={16}
                              />
                              {moment(details.created_date_time).format(
                                "ddd , D MMM YYYY"
                              )}
                            </div>
                            <div className="style_loan_txt mb-4 ms-4 pe-5">
                              {details.message}
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-1"></div>
            {/* <div className="col-5">
              <div className="ten_text">Tenure Extension Request</div>
              <div className="bolder_text mt-1">
                {props.data.extend_tenure}{" "}
                {props.data.extend_tenure == 1 ? " Month" : " Months"}
              </div>

              <div className="bolder_text mt-1">

                <Form.Group
                  className="mb-3"
                  controlId="exampleForm.ControlTextarea1"
                >
                  <Form.Label className="reason_text mt-3">Reason</Form.Label>
                  <Form.Control
                    as="textarea"
                    placeholder=""
                    id="admin_notes"
                    name="admin_notes"
                    onChange={handleChangeInput}
                    // {props.data.notes}
                  />
                </Form.Group>
              </div>
            </div> */}
            <div className="col-5" style={{ maxHeight: '60vh', overflowY: 'auto', paddingRight: 8 }}>
              <div className="ten_text">Tenure Extension Request</div>
              <div className="bolder_text mt-1">
                {props.data.extend_tenure}{" "}
                {props.data.extend_tenure == 1 ? " Month" : " Months"}
              </div>

              {/* Extension Type Dropdown */}
              <Form.Group className="mb-3 mt-3">
                <Form.Label className="reason_text">
                  Extension Type <span style={{ color: '#ED5151' }}>*</span>
                </Form.Label>
                <Form.Select
                  name="extension_type"
                  value={extensionType}
                  onChange={handleExtensionTypeChange}
                >
                  <option value="">— Select type —</option>
                  <option value="equal">Equal Extension</option>
                  <option value="principal_deferral">
                    Equal Extension with Principal Deferral
                  </option>
                  <option value="total_deferral">
                    Equal Extension with Total Deferral
                  </option>
                </Form.Select>
              </Form.Group>

              {/* Loading state */}
              {previewLoading && (
                <div style={{ fontSize: 12, color: '#888', padding: '6px 0' }}>
                  Calculating schedule...
                </div>
              )}

              {/* Schedule preview table — shown after API returns */}
              {!previewLoading && previewSchedule.length > 0 && (
                <div style={{
                  border: '1px solid #e0e0e0',
                  borderRadius: 8,
                  overflow: 'hidden',
                  marginBottom: 12,
                  fontSize: 12
                }}>
                  {/* Table header */}
                  <div style={{
                    background: '#f5f7fa',
                    padding: '6px 12px',
                    fontWeight: 600,
                    fontSize: 11,
                    color: '#555',
                    textTransform: 'uppercase',
                    letterSpacing: '0.04em',
                    borderBottom: '1px solid #eee'
                  }}>
                    Revised schedule preview
                  </div>

                  {/* Table */}
                  <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                    <thead>
                      <tr style={{ background: '#fafafa' }}>
                        {['#', 'Principal', 'Interest', 'Total', 'Note'].map((h) => (
                          <th
                            key={h}
                            style={{
                              padding: '5px 8px',
                              borderBottom: '1px solid #eee',
                              fontWeight: 500,
                              color: '#888',
                              textAlign: 'left',
                              fontSize: 11
                            }}
                          >
                            {h}
                          </th>
                        ))}
                      </tr>
                    </thead>
                    <tbody>
                      {previewSchedule.map((row, i) => {
                        const isDeferral = row.principal === 0 && row.bennefin_profit === 0;
                        const isBullet = row.is_tenure_both_principal_interest === 1 && row.principal > 0;
                        return (
                          <tr
                            key={i}
                            style={{
                              borderBottom: '1px solid #f0f0f0',
                              fontStyle: isDeferral ? 'italic' : 'normal',
                              color: isBullet ? '#185FA5' : isDeferral ? '#aaa' : 'inherit',
                              fontWeight: isBullet ? 600 : 400,
                            }}
                          >
                            <td style={{ padding: '5px 8px' }}>{i + 1}</td>
                            <td style={{ padding: '5px 8px' }}>
                              {isDeferral
                                ? '—'
                                : `BHD ${Number(row.principal).toFixed(2)}`}
                            </td>
                            <td style={{ padding: '5px 8px' }}>
                              {isDeferral
                                ? '—'
                                : `BHD ${(Number(row.bennefin_profit)).toFixed(2)}`}
                            </td>
                            <td style={{ padding: '5px 8px' }}>
                              {`BHD ${Number(row.total_payment).toFixed(2)}`}
                            </td>
                            <td style={{ padding: '5px 8px', color: '#888', fontSize: 11 }}>
                              {isBullet
                                ? 'Bullet payment'
                                : isDeferral
                                  ? 'Deferral'
                                  : extensionType === 'equal'
                                    ? 'Equal Extension'
                                    : 'Resumes original'}
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>

                  {/* Total interest footer */}
                  <div style={{
                    padding: '6px 12px',
                    background: '#f5f7fa',
                    fontSize: 11,
                    color: '#555',
                    borderTop: '1px solid #eee'
                  }}>
                    Total interest: <strong>BHD {Number(totalInterest).toFixed(2)}</strong>
                  </div>
                </div>
              )}

              {/* Reason / admin notes */}
              <Form.Group className="mb-3">
                <Form.Label className="reason_text mt-2">Reason</Form.Label>
                <Form.Control
                  as="textarea"
                  placeholder=""
                  id="admin_notes"
                  name="admin_notes"
                  onChange={handleChangeInput}
                />
              </Form.Group>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer className="d-flex justify-content-between ps-3 pe-3">
          <div>
            <label htmlFor="Assignee">
              <p className="ms-2">Assignee</p>
            </label>
            <select
              id="assignee"
              name="assignee"
              className="form-select shadow-ben"
              aria-label="form-select example"
              onChange={handleChangeInput}
            >
              <option value={user}>{user}</option>
            </select>
          </div>
          <div>
            <button
              className="gray_btn btn mx-2 px-3 py-2"
              variant="secondary"
              onClick={handleClose}
            >
              Close
            </button>
            <button
              className="btn mx-2 py-2 px-3"
              style={{ backgroundColor: "#ED5151", color: "white" }}
              variant="secondary"
              onClick={handleShowReject}
            >
              Reject
            </button>
            <button
              className="btn blue_btn ms-2 py-2"
              variant="primary"
              disabled={activeTabBool || !extensionType}
              onClick={handleSubmit(handleSavechanges)}
            >
              Push To Investor
            </button>
          </div>
        </Modal.Footer>
      </Modal>

      <Modal show={show} onHide={handleCloseRejectClose}>
        <Modal.Header closeButton>
          <Modal.Title>Alert</Modal.Title>
        </Modal.Header>
        <div className="alert_modal">Are you sure you want to reject?</div>
        <div className="p-2 d-flex justify-content-end gap-3">
          <button
            className="btn px-3"
            style={{ backgroundColor: "grey", color: "white" }}
            variant="primary"
            onClick={handleCloseRejectClose}
          >
            Cancel
          </button>
          <button
            className="btn px-4"
            style={{ backgroundColor: "#ED5151", color: "white" }}
            variant="danger"
            onClick={handleCloseReject}
          >
            Yes
          </button>
        </div>
      </Modal>
    </>
  );
};

export default AdminExtendTenureRequest;
